import { Grid, Tooltip } from "@material-ui/core";
import GlobitsPagination from "app/common/Component/Table/Pagination";
import {
  LAServiceRequestItemStatusEnum,
  PathModule,
  SERVICE_TREATMENT_TYPE_WARRANTY,
  VALUE_TAB_CONSTRUCTION_MATERIALS_PRODUCT,
} from "app/common/LocalConst";
import {
  getAge,
  getDate,
  getGender,
  isAdmin,
  isRoleBranchManager,
  isRoleCashier,
  isRoleChiefTechician,
  isRoleHisReadOnly,
  isRoleTechician,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import lodash from "lodash";
import { observer } from "mobx-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import Config from "../../appConfig";
import { CopyableCodeCell, PhoneNumberCell } from "utils";

const ConstructionMaterialsSynthesisList = () => {
  const { t } = useTranslation();

  const {
    searchObject,
    handleChangeFormSearch,
    pageConstructionMaterials,
    currentTab,
    setListSelected,
    listSelected,
  } = useStore().treatmentManagementStore.constructionMaterialsSynthesisStore;

  const renderBirthDate = (patient) => {
    let textBirthDate = "";
    if (patient?.birthDate) {
      textBirthDate += `${getDate(patient?.birthDate)} `;
    }
    if (patient?.age) {
      textBirthDate += `- ${getAge(patient?.birthDate)}`;
    }
    return textBirthDate;
  };

  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isAdmins = isAdmin();
  const isRoleBranchManagers = isRoleBranchManager();
  const isReadonly = isRoleHisReadOnly();
  const isCashier = isRoleCashier();
  const hasPermission =
    isRoleCt || isAdmins || isRoleBranchManagers || isReadonly || isCashier;

  const renderSynthesisText = (item) => {
    if (!item?.storeRequestItemId) return "";
    return item?.storeRequestCode
      ? `Đã tổng hợp (${item?.storeRequestCode})`
      : "Đã tổng hợp";
  };

  function handleViewStaffInfo(rowData) {
    const currentLocation = window.location.href;
    let url = "";

    if (currentLocation.includes(PathModule.PATIENT_MANAGEMENT)) {
      url =
        Config.ROOT_PATH +
        PathModule.PATIENT_MANAGEMENT +
        `/patient-general?patientId=${rowData?.encounter?.patient?.id}`;
    } else if (currentLocation.includes(PathModule.TREATMENT_MANAGEMENT)) {
      url =
        Config.ROOT_PATH +
        PathModule.TREATMENT_MANAGEMENT +
        `/treatment-patient-info-detail?patientId=${rowData?.encounter?.patient?.id}`;
    }

    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  }

  function handleViewTreatmentInfo(rowData) {
    let url = "";
    url =
      Config.ROOT_PATH +
      PathModule.TREATMENT_MANAGEMENT +
      `/treatment-update-results-detail/${rowData?.id}`;

    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  }
  const label =
    currentTab === VALUE_TAB_CONSTRUCTION_MATERIALS_PRODUCT
      ? "sản phẩm"
      : "vật tư";
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <div className="table-scroll-wrapper">
          <table className="report-table">
            <thead>
              <tr>
                <th>STT</th>
                <th align="center">
                  <div>
                    <input
                      type="checkbox"
                      style={{ width: "16px", height: "16px" }}
                      checked={
                        pageConstructionMaterials?.content?.length > 0 &&
                        pageConstructionMaterials?.content?.length ===
                        listSelected?.length
                      }
                      onChange={(e) => {
                        let checked = e?.target?.checked;
                        if (checked) {
                          setListSelected([
                            ...pageConstructionMaterials?.content,
                          ]);
                        } else {
                          setListSelected([]);
                        }
                      }}
                    />
                  </div>
                </th>
                <th>Tên khách hàng</th>
                <th>Dịch vụ</th>
                <th>Dịch vụ bảo hành chi tiết</th>
                <th>Ngày sinh</th>
                <th>Số điện thoại</th>
                <th>Cơ sở</th>
                <th>Phòng</th>
                <th>Người chỉ định</th>
                <th>Trạng thái</th>
                <th>Nhóm {label}</th>
                <th>{lodash.startCase(label)}</th>
                <th>Số lượng</th>
                <th>Đơn vị tính</th>
                <th>Thông tin tổng hợp</th>
                <th>Kết quả</th>
                <th>Ghi chú</th>
              </tr>
            </thead>

            <tbody>
              {(pageConstructionMaterials?.content || [])?.map(
                (rowData, index) => {
                  let listData =
                    currentTab == VALUE_TAB_CONSTRUCTION_MATERIALS_PRODUCT
                      ? rowData?.diagnosticReports?.[0]?.medicationRequests?.[0]
                        ?.drugOrder
                      : rowData?.diagnosticReports?.[0]
                        ?.medicalSupplyRequests?.[0]?.medicalSupplyOrderDtos;


                  let rowSpan = listData?.length || 1;

                  return (
                    <>
                      <tr key={index}>
                        <td align="center" rowSpan={rowSpan}>
                          {index + 1}
                        </td>
                        <td rowSpan={rowSpan}>
                          <div>
                            <input
                              type="checkbox"
                              style={{ width: "16px", height: "16px" }}
                              checked={listSelected?.some(
                                (el) => el?.id === rowData?.id
                              )}
                              onChange={(e) => {
                                let checked = e?.target?.checked;
                                if (checked) {
                                  setListSelected([...listSelected, rowData]);
                                } else {
                                  let newArray = [...listSelected]?.filter(
                                    (el) => el?.id !== rowData?.id
                                  );
                                  setListSelected(newArray);
                                }
                              }}
                            />
                          </div>
                        </td>
                        {/* --- Tên khách hàng --- */}
                        <td rowSpan={rowSpan}>
                          <div
                            style={{
                              cursor: hasPermission ? "pointer" : "default",
                            }}
                            onClick={() => {
                              if (!hasPermission) return;
                              handleViewStaffInfo(rowData);
                            }}
                          >
                            <Tooltip title="Thông tin khách hàng">
                              <div>
                                <p>
                                  <b>
                                    {rowData?.encounter?.patient?.displayName}
                                  </b>
                                </p>

                                <p className="flex">
                                  <span style={{ color: "#4276a4" }}>
                                    <CopyableCodeCell
                                      value={rowData?.encounter?.patient?.code}
                                      size="small"
                                    />
                                  </span>

                                  <span>
                                    {rowData?.encounter?.patient?.gender && (
                                      <>
                                        {" "}
                                        |{" "}
                                        {getGender(
                                          rowData?.encounter?.patient?.gender
                                        )}
                                      </>
                                    )}
                                  </span>
                                </p>
                              </div>
                            </Tooltip>
                          </div>
                        </td>

                        {/* --- Dịch vụ --- */}
                        <td rowSpan={rowSpan}>
                          <div
                            className="pl-1 pr-1 pointer"
                            onClick={() => handleViewTreatmentInfo(rowData)}
                          >
                            <div>
                              <span className="service-code">
                                {rowData?.service?.code}
                              </span>{" "}
                              <span className="service-name">
                                {rowData?.service?.tradeName ||
                                  rowData?.service?.name}
                              </span>
                            </div>

                            {rowData?.times && (
                              <span className="font-size-12">
                                {`Lần ${rowData?.treatmentType ===
                                  SERVICE_TREATMENT_TYPE_WARRANTY
                                  ? "bảo hành"
                                  : "điều trị"
                                  }: ${rowData?.times} ${rowData?.unLimited
                                    ? "(Không giới hạn)"
                                    : "| " + (rowData?.totalTreatmentTimes || 0)
                                  }`}
                              </span>
                            )}
                          </div>
                        </td>

                        {/* --- Dịch vụ bảo hành chi tiết --- */}
                        <td rowSpan={rowSpan}>
                          <div className="pl-1 pr-1">
                            <div>
                              <span className="service-code">
                                {rowData?.service?.warrantyService?.code}
                              </span>{" "}
                              <span className="service-name">
                                {rowData?.service?.warrantyService?.name}
                              </span>
                            </div>
                          </div>
                        </td>

                        {/* --- Ngày sinh --- */}
                        <td rowSpan={rowSpan}>
                          {renderBirthDate(rowData?.encounter?.patient)}
                        </td>

                        {/* --- Số điện thoại --- */}
                        <td rowSpan={rowSpan}>
                          <PhoneNumberCell value={rowData?.encounter?.patient?.phoneNumber} />
                        </td>

                        {/* --- Cơ sở --- */}
                        <td rowSpan={rowSpan}>{rowData?.department?.name}</td>

                        <td rowSpan={rowSpan}>{rowData?.room?.name}</td>

                        {/* --- Người chỉ định --- */}
                        <td rowSpan={rowSpan}>
                          {rowData?.assigner?.staffName}
                        </td>

                        {/* --- Trạng thái --- */}
                        <td rowSpan={rowSpan}>
                          {
                            LAServiceRequestItemStatusEnum.fromValue(
                              rowData?.itemStatus
                            )?.name
                          }
                        </td>
                        <td>{listData?.[0]?.abstractProduct?.name}</td>
                        <td>
                          {listData?.[0]?.drugName ||
                            listData?.[0]?.medicalSupplyName}
                        </td>
                        <td>
                          {listData?.[0]?.actualQuantity}
                        </td>
                        <td>
                          {listData?.[0]?.usedUnit?.name ||
                            listData?.[0]?.unit?.name}
                        </td>
                        <td>{renderSynthesisText(listData?.[0])}</td>

                        {/* --- Kết quả --- */}
                        <td rowSpan={rowSpan} style={{ width: "200px" }}>
                          <div>
                            <strong style={{ marginRight: "8px" }}>
                              Kết luận:
                            </strong>
                            <span style={{ whiteSpace: "pre-wrap" }}>
                              {rowData?.diagnosticReportConclude || "Không có"}
                            </span>
                          </div>
                          <div>
                            <strong style={{ marginRight: "8px" }}>
                              Ghi chú:
                            </strong>
                            <span style={{ whiteSpace: "pre-wrap" }}>
                              {rowData?.diagnosticReportNote || "Không có"}
                            </span>
                          </div>
                        </td>

                        {/* --- Ghi chú --- */}
                        <td rowSpan={rowSpan}>{rowData?.note}</td>
                      </tr>
                      {listData?.slice(1).map((el, subIndex) => (
                        <tr key={subIndex}>
                          <td>{el?.abstractProduct?.name}</td>
                          <td>{el?.drugName || el?.medicalSupplyName}</td>
                          <td>{el?.actualQuantity || el?.doseValue || el?.quantity}</td>
                          <td>{el?.usedUnit?.name || el?.unit?.name}</td>
                          <td>{renderSynthesisText(el)}</td>
                        </tr>
                      ))}
                    </>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
        <GlobitsPagination
          pageIndex={searchObject.pageIndex}
          pageSize={searchObject.pageSize}
          totalElements={pageConstructionMaterials?.totalElements}
          totalPages={pageConstructionMaterials?.totalPages}
          setPageIndex={(pageIndex) => handleChangeFormSearch({ pageIndex })}
          setPageSize={(pageSize) => handleChangeFormSearch({ pageSize })}
        />
      </Grid>
    </Grid>
  );
};

export default memo(observer(ConstructionMaterialsSynthesisList));

// Tạo phiếu xuất kho

// Cho chọn ra ds điều trị từ các dòng trong từng tab dể tổng hợp;
// Có 1 nút: Tổng hợp tạo phiếu xuất -> Bấm vào đây thì sv viết api,
// client truyền lên thông tin các điều trị đã chọn,
//  sv lấy ra các vật tư hoặc sản phẩm đã dùng tương ứng
//   và tổng hợp lại để ra 1 form bao gồm:
// - sản phẩm nào, tổng sô lượng bao nhiêu, đơn vị tính
// - bên trên cho chọn các thông tin: Kho xuất - cho chọn;
// người xuất - mặc định theo tk
// (admin thì đc sửa còn lại k); TG xuất; Cơ sở
